import React from "react";
import { clsx } from "clsx";

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
    label?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, className, id, ...props }) => {
    const inputId = id ?? props.name;
    return (
        <label htmlFor={inputId} className={clsx("inline-flex items-center gap-2 text-sm text-neutral-dark dark:text-white", className)}>
            <input
                id={inputId}
                type="checkbox"
                className="h-4 w-4 rounded border-neutral-border text-primary focus:ring-primary"
                {...props}
            />
            {label}
        </label>
    );
};

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
    label?: string;
}

export const Radio: React.FC<RadioProps> = ({ label, className, id, ...props }) => {
    const inputId = id ?? `${props.name}-${props.value}`;
    return (
        <label htmlFor={inputId} className={clsx("inline-flex items-center gap-2 text-sm text-neutral-dark dark:text-white", className)}>
            <input
                id={inputId}
                type="radio"
                className="h-4 w-4 border-neutral-border text-primary focus:ring-primary"
                {...props}
            />
            {label}
        </label>
    );
};

export interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
    label?: string;
}

export const Switch: React.FC<SwitchProps> = ({ label, className, id, checked, ...props }) => {
    const inputId = id ?? props.name;
    return (
        <label htmlFor={inputId} className={clsx("inline-flex cursor-pointer items-center gap-3 text-sm", className)}>
            <span className="relative inline-flex h-6 w-11 shrink-0 items-center">
                <input id={inputId} type="checkbox" className="peer sr-only" checked={checked} {...props} />
                <span className="absolute inset-0 rounded-full bg-neutral-border transition peer-checked:bg-primary peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-2" />
                <span className="absolute start-0.5 h-5 w-5 rounded-full bg-white shadow transition peer-checked:translate-x-5" />
            </span>
            {label ? <span className="text-neutral-dark dark:text-white">{label}</span> : null}
        </label>
    );
};
